import AbstractControlEditor from "@/components/CustomForm/Design/ControlEditor/AbstractControlEditor";

export default class ABswitch extends AbstractControlEditor {}
